<template>
    <div class="flex justify-end">
        <button
            type="button"
            class="rounded-full p-1 transition-colors hover:bg-gray-100 disabled:cursor-default disabled:opacity-50"
            :disabled="pending"
            :aria-label="group.is_favorite ? $t('views.monitoring.groupOverview.tables.barnTable.favorite.remove') : $t('views.monitoring.groupOverview.tables.barnTable.favorite.add')"
            @click.stop="emit('toggle', group)"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-7"
                :class="{ 'text-yellow-400': group.is_favorite, 'text-gray-200 hover:text-gray-300': !group.is_favorite }"
            >
                <path
                    fill-rule="evenodd"
                    d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                    clip-rule="evenodd"
                />
            </svg>
        </button>
    </div>
</template>

<script setup lang="ts">
import { ProductionGroup } from '@/types';

// The yellow-heart favorite toggle shown on a group's table row - identical in the "all groups" and
// "by section" DataTable, so one definition serves both instead of two copies drifting apart.
defineProps<{
    group: ProductionGroup;
    pending: boolean;
}>();

const emit = defineEmits<{
    toggle: [group: ProductionGroup];
}>();
</script>
